import { a5ScreeningRequests } from "@/api/(requests)/a5Screening";
import { patientRequests } from "@/api/(requests)/patient";
import { sharedRequests } from "@/api/(requests)/shared";

import * as actionTypes from "./actionTypes";

const nextQuestion = (nextQuestion, isLast, completionPercentage) => {
  return {
    payload: { completionPercentage, isLast, nextQuestion },
    type: actionTypes.A5_NEXT_QUESTION,
  };
};

const previousQuestion = (payload) => {
  return {
    payload,
    type: actionTypes.A5_PREVIOUS_QUESTION,
  };
};

const selectOption = (options) => {
  return {
    payload: options,
    type: actionTypes.A5_OPTION_SELECTED,
  };
};

export const setA5Details = (payload) => {
  return {
    payload: payload,
    type: actionTypes.A5_UPDATE,
  };
};

export const getNextQuestion = (requestBody, headers) => (dispatch) => {
  a5ScreeningRequests.fetch_next_question({ data: requestBody, headers }).then((response) => {
    let data = response;
    let nextQ = data.question;
    let completionPercentage = data.percentage;
    let isLast = (nextQ && nextQ.is_last) || false;

    dispatch(nextQuestion(nextQ, isLast, completionPercentage));
  });
};

export const getQuestion = (requestBody, _headers) => (dispatch) => {
  patientRequests.get_next_question(requestBody).then((response) => {
    let data = response;
    let nextQ = data.question;
    let completionPercentage = data.percentage;
    let isLast = (nextQ && nextQ.is_last) || false;

    dispatch(setA5Details(response["question"]));
    dispatch(nextQuestion(nextQ, isLast, completionPercentage));
  });
};

export const submitQuestion = (requestBody, _headers) => (dispatch) => {
  patientRequests.submit_next_question(requestBody).then((response) => {
    let data = response;
    let nextQ = data.question;
    let completionPercentage = data.percentage ? Math.ceil(data.percentage) : data.percentage;
    let isLast = (nextQ && nextQ.is_last) || false;

    dispatch(nextQuestion(nextQ, isLast, completionPercentage));
  });
};

export const getPrevQuestion = (requestBody, _headers) => (dispatch) => {
  patientRequests.get_last_question(requestBody).then((response) => {
    let data = response;
    let nextQ = data.question;
    let completionPercentage = data.percentage;
    let isLast = (nextQ && nextQ.is_last) || false;

    dispatch(nextQuestion(nextQ, isLast, completionPercentage));
  });
};

export const updateA5Details = (requestBody, headers) => (dispatch) => {
  sharedRequests.update_a5_screening_details({ data: requestBody, headers }).then((response) => {
    dispatch(setA5Details(response));
  });
};

export const getPreviousQuestion = (requestBody, headers) => (dispatch) => {
  a5ScreeningRequests
    .fetch_previous_question({ context: { showLoader: false }, data: requestBody, headers })
    .then((response) => {
      let data = response;
      let completionPercentage = data.percentage;
      let payload = {
        completionPercentage,
        currentQuestion: data.question,
        isLast: data.question.is_last,
      };

      dispatch(previousQuestion(payload));
    });
};

export const setSelectedOptions = (selectedOptions, selectedOptionFull) => (dispatch) => {
  dispatch(selectOption({ selectedOptionFull, selectedOptions }));
};
